export const SITE_CONSTANTS = {
    HOMEPAGE: "The Outlook Inn — Serenity Now",
    ROOMS_PAGE: "Rooms — The Outlook Inn",
    CONTACT_US_PAGE: "Contact Us — The Outlook Inn",
    BOOK_PAGE: "Book Now — The Outlook Inn",
    VIEW_BOOKING: "View Booking — The Outlook Inn",
};
